import { useContext } from 'react'
import { ThemeProvider } from 'styled-components'
import { colors, fonts, colorsAlternative } from './tokens'
import * as helpers from './helpers'
import GlobalStyle from './globalStyle'
import { GlobalContext } from '../Global'

const Theme = ({ children }) => {
  const {
    state: { isAlternativeActive },
  } = useContext(GlobalContext)
  return (
    <ThemeProvider
      theme={{
        fonts,
        alternativeScheme: isAlternativeActive,
        colors: isAlternativeActive ? colorsAlternative : colors,
        ...helpers,
      }}
    >
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default Theme
